// src/api/index.ts (your existing index.ts file)

import { contentBlock } from '@/utils/graphql/contentblock'
export function getContentBlock (client: any, alias: String) {
    return new Promise ((resolve) => {
        client.query({
            query: contentBlock,
            variables: {
                alias: alias
            },
        }).then((data: any) => {
            if(data.data.contentBlock) {
                resolve(data.data.contentBlock[0])
            }
        });
    }
    )
}

import { clientList } from '@/utils/graphql/client'
export function getClientLogos (client: any) {
    return new Promise ((resolve) => {
        client.query({
            query: clientList
        }).then((data: any) => {
            if(data.data.client) {
                resolve(data.data.client.filter((data: any) => { return data.showOnHomepage }))
            }
        });
    }
    )
}

import { clientQuotes } from '@/utils/graphql/contentblock'
export function getClientQuotes (client: any) {
    return new Promise ((resolve) => {
        client.query({
            query: clientQuotes
        }).then((data: any) => {
            if(data.data.contentBlock) {
                resolve(data.data.contentBlock[0])
            }
        });
    }
    )
}

export function getClientSlug (alias: String) {
    if(alias == '') { return alias }
    return alias.replace('client-', '')
}

export function getSubsidiarySlug (alias: String) {
    if(alias == '') { return alias }
    return alias.replace('subsidiary-', '')
}

import { caseStudyThumbnail } from '@/utils/graphql/client'
export function getCaseStudyThumbnail (client: any) {
    return new Promise ((resolve) => {
        client.query({
            query: caseStudyThumbnail
        }).then((data: any) => {
            if(data.data.client) {
                resolve(data.data.client.filter((data: any) => {
                    const flow = data.flow;
                    return flow != null && flow.contentItems.length > 0;
                }))
            }
        });
    }
    )
}

import { subsidiaries } from '@/utils/graphql/subsidiaries'
export function getSubsidiaries (client: any) {
    return new Promise ((resolve) => {
        client.query({
            query: subsidiaries
        }).then((data: any) => {
            if(data.data.subsidiaries) {
                resolve(data.data.subsidiaries)
            }
        });
    }
    )
}

import { subsidiaryDetails } from '@/utils/graphql/subsidiaries'
export function getSubsidiaryDetails (client: any, alias: String) {
    return new Promise ((resolve) => {
        client.query({
            query: subsidiaryDetails,
            variables: {
                alias: alias
            },
        }).then((data: any) => {
            if(data.data.subsidiaries) {
                resolve(data.data.subsidiaries[0])
            }
        });
    }
    )
}

interface HomeBannerData {
    subtitle: string;
    displayText: string;
    bannerBackground: {
        urls: string[];
    };
}

import { homeBannerQuery } from '@/utils/graphql/homebanner';

export function getHomeBanner(client: any): Promise<HomeBannerData | null> {
    return new Promise((resolve) => {
        client.query({
            query: homeBannerQuery
        }).then((data: any) => {
            if (data.data.homeBanner && data.data.homeBanner.length > 0) {
                resolve(data.data.homeBanner[0] as HomeBannerData);
            } else {
                resolve(null);
            }
        }).catch((error: any) => {
            console.error("Error fetching home banner:", error);
            resolve(null);
        });
    });
}

interface AwardData {
    displayText: string;
    year: number;
}

import { awardsListQuery } from '@/utils/graphql/awards';

export function getAwards(client: any): Promise<AwardData[]> {
    return new Promise((resolve) => {
        client.query({
            query: awardsListQuery
        }).then((data: any) => {
            if (data.data.awards) {
                resolve(data.data.awards as AwardData[]);
            } else {
                resolve([]);
            }
        }).catch((error: any) => {
            console.error("Error fetching awards:", error);
            resolve([]);
        });
    });
}

import { serviceList } from '@/utils/graphql/service'
export async function getServiceList (client: any) {
    try {
      const { data } = await client.query({
        query: serviceList,
      })
      return data.service
    } catch (err) {
      console.error(err)
      return null;
    }
}

import { serviceDetail, serviceDetail2 } from '@/utils/graphql/service'
export async function getServiceDetail (client: any, path: String) {
    try {
      const { data: data1 } = await client.query({
        query: serviceDetail,
        variables: {
          path: path
        }
      })

      const { data: data2 } = await client.query({
        query: serviceDetail2,
        variables: {
          path: path
        }
      })

      const coreData = data1.service[0]
      const bagData = data2.service[0]

      if (!coreData) {
        return null;
      }

      const mergedResult = {
        ...coreData,
        ...bagData
      };

      return mergedResult;
    } catch (err) {
      console.error("Error fetching service detail with split queries:", err)
      return null;
    }
}

import { faqsQuery } from '@/utils/graphql/faq';
export async function getFaqs(client: any): Promise<any> {
    try {
        const { data } = await client.query({
            query: faqsQuery,
        });
        return data;
    } catch (error) {
        console.error("Error fetching FAQ data:", error);
        return null;
    }
}

import { caseStudyList, caseStudyDetail } from '@/utils/graphql/casestudy'

export async function getCaseStudyList (client: any) {
    try {
      const { data } = await client.query({
        query: caseStudyList
      })
      return data.caseStudy
    } catch (err) {
      console.error("Error fetching case study list:", err)
      return null;
    }
}

export async function getCaseStudyDetail (client: any, path: String) {
    try {
      const { data } = await client.query({
        query: caseStudyDetail,
        variables: {
          path: path
        }
      })
      return data.caseStudy[0]
    } catch (err) {
      console.error("Error fetching case study details:", err)
      return null;
    }
}

import { ourWorkQuery } from '@/utils/graphql/ourwork'
export async function getOurWork(client: any): Promise<any[] | null> {
    try {
      const { data } = await client.query({
        query: ourWorkQuery,
      });
      return data.ourWork;
    } catch (err) {
      console.error("Error fetching Our Work data:", err);
      return null;
    }
  }

import { ourClientsQuery } from '@/utils/graphql/ourclients'
export async function getOurClients (client: any) {
  try {
    const { data } = await client.query({
      query: ourClientsQuery,
    })
    return data.ourClients[0] || null
  } catch (err) {
    console.error("Error fetching our clients data:", err)
    return null;
  }
}

import { specialistServiceList, specialistServiceDetail } from '@/utils/graphql/specialistdivision';

export async function getSpecialistServiceList(client: any) {
    try {
        const { data } = await client.query({
            query: specialistServiceList,
        });
        return data.specialistService;
    } catch (err) {
        console.error("Error fetching specialist service list:", err);
        return null;
    }
}

export async function getSpecialistServiceDetail(client: any, path: String) {
    try {
        const { data } = await client.query({
            query: specialistServiceDetail,
            variables: {
                path: path
            }
        });
        return data.specialistService[0];
    } catch (err) {
        console.error("Error fetching specialist service detail:", err);
        return null;
    }
}

export function getSpecialistDivisionSlug(alias: string) {
    if (alias === '') { return alias; }
    return alias.replace('specialistService-', '');
}

import { aboutUsQuery } from '@/utils/graphql/aboutus';

export async function getAboutUsContent(client: any) {
    try {
        const { data } = await client.query({
            query: aboutUsQuery,
        });
        return data.aboutUsContent[0] || null;
    } catch (err) {
        console.error("Error fetching About Us content:", err);
        return null;
    }
}

import { brandMarquee } from '@/utils/graphql/brandmarquee'

export function getBrandMarquee(client: any) {
  return new Promise((resolve) => {
    client.query({
      query: brandMarquee,
    }).then((data: any) => {
      if (data.data.brandMarqueeLogo) {
        const formatted = data.data.brandMarqueeLogo.map((item: any) => ({
          src: item.logoImage?.urls?.[0] ? `${item.logoImage.urls[0]}` : '',
          alt: item.altText || 'Brand Logo',
          link: item.linkURL || null
        }));
        resolve(formatted);
      } else {
        resolve([]);
      }
    }).catch((error: any) => {
      console.error("Error fetching brand marquee logos:", error);
      resolve([]);
    });
  });
}

import { vacanciesQuery, Vacancy } from '@/utils/graphql/vacancies';

const DEFAULT_APPLICATION_URL = 'https://forms.office.com/r/NpMV48tN4M';

export async function getVacancies(client: any): Promise<Vacancy[]> {
    try {
        const { data } = await client.query({
            query: vacanciesQuery,
        });
        
        if (data.vacancies) {
            return data.vacancies.map((vacancy: any) => ({
                ...vacancy,
                applicationURL: vacancy.applicationURL || DEFAULT_APPLICATION_URL
            })) as Vacancy[];
        }
        
        return [];
    } catch (err) {
        console.error("Error fetching vacancies:", err);
        return [];
    }
}